export default __webpack_public_path__ + "static/media/ticketalt.697ccae4.svg";